<template>
  <div class="ads-put-in-prod">
    <div class="header-box">
      <span class="header-label">日期</span>
        <el-date-picker v-model="date" type="daterange" align="right" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" size="small"
          value-format="yyyy-MM-dd" style="width: 230px;">
        </el-date-picker>
      <el-button type="primary" size="small" @click="dialogFormVisible = true">添加商品投放</el-button>
      <el-button type="primary" size="small" v-on:click="onQueryBtnClick">查询</el-button>
    </div>
    <el-dialog title="商品信息" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="投放类型" :label-width="formLabelWidth">
          <el-radio-group v-model="form.matchType">
            <el-radio :label="9">定位与表示的ASIN相同的ASIN</el-radio>
            <!-- <el-radio :label="10">定位到符合Prime Shipping资格的产品</el-radio>
            <el-radio :label="11">定位年龄范围内的年龄范围</el-radio>
            <el-radio :label="12">与表达的题材有关的目标产品</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品asin" :label-width="formLabelWidth">
          <el-input v-model="form.asin" autocomplete="off" onkeyup="this.value = this.value.replace(/[^/A-Z-0-9]/g,'')"></el-input>
        </el-form-item>

        <el-form-item label="竞价" :label-width="formLabelWidth">
          <el-input v-model="form.bid" autocomplete="off" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProduct">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量修改竞价" :visible.sync="bidBatchEditVisible" width="300px">
      <el-form>
        <el-form-item label="竞价" :label-width="formLabelWidth">
          <el-input v-model="batchUpdateOfBid" autocomplete="off" style="width: 100px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bidBatchEditVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAdGroupTargetListBidByAdGroupId(batchUpdateOfBid)">确 定</el-button>
      </div>
    </el-dialog>
    <ads-table  :tableData = "tableData"
                :theadList = "theadList"
                @switch-change = "switchChange"
                @input-change = "inputChange"
                @image-click="imageClick"
                @head-switch-change="updateAdGroupTargetListStatusByAdGroupId"
                @head-text-button-click="bidBatchEditVisible = true"
                >
    </ads-table>
  </div>
</template>

<script>
  import adsTable from '_c/table'
  import {adsModules} from '@r'

  export default {

  data () {
    return {
      batchUpdateOfBid: "",
      bidBatchEditVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      form: {
        asin: null,
        matchType: 9,
        bid: ""
      },
      tableData: [],
      overallStatus: 2,
      theadList: [
        {
          id: '1',
          propName: 'index',
          labelName: '序号',
          textAlign: "center",
        },
        {
          id: '2-1',
          propName: 'imageUrl',
          labelName: '商品图片',
          width: '60px',
          showImage: true
        },
        {
          id: '2-2',
          propName: 'asin',
          labelName: 'ASIN',
          width: '60px',
          showLink: true
        },
        {
          id: '2-3',
          propName: 'sellerName',
          width: '66px',
          labelName: '卖家',
        },
        {
          id: '2',
          propName: 'status',
          labelName: '有效',
          width: '65px',
          showSwitch: true,
          showHeadSwitch: true,
          overallStatus: this.overallStatus,
          activeValue: 1,
          inactiveValue: 2,
          headActiveValue: 1,
          headInactiveValue: 2,
        },
        {
          id: '15',
          propName: 'productRank',
          labelName: '商品排名',
          width:"50px",
          textAlign: "right",
          sortable: true,
          sortMethod: function (rowA, rowB) {
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.productRank) - parseFloat(rowB.productRank);
          }
        },
        {
          id: '16',
          propName: 'rank',
          labelName: '本品排名',
          width:"50px",
          textAlign: "right",
        },
        {
          id: '12',
          propName: 'rankOfMolova',
          width: '63px',
          labelName: '本品关联商品排名',
          textAlign: "right",
        },
        {
          id: '13',
          propName: 'rankOfCompetitionProduct',
          width: '63px',
          labelName: '竞品关联商品排名',
          textAlign: "right",
        },
        {
          id: '14',
          propName: 'asinOfCompetitionProduct',
          labelName: '竞品asin',
          width: '60px',
        },
        {
          id: '3',
          propName: 'typeText',
          width: '77px',
          labelName: '类别和商品'
        },
        {
          id: '3-1',
          propName: 'impressions',
          labelName: '曝光量',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.impressions)-parseFloat(rowB.impressions);
        },
          textAlign: "right",
        },
        {
          id: '3-2',
          propName: 'clicks',
          labelName: '点击数',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.clicks)-parseFloat(rowB.clicks);
        },
          textAlign: "right",
        },
        {
          id: '3-3',
          propName: 'clickRate',
          labelName: '点击率',
          sortable: true,
          width: '70px',
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.clickRate)-parseFloat(rowB.clickRate);
        },
          textAlign: "right",
        },
        {
          id: '5',
          propName: 'servingStatus',
          width: '50px',
          labelName: '状态'
        },
        {
          id: '6',
          propName: 'bid',
          labelName: '竞价',
          width: '70px',
          showInput: true,
          showHeadTextButton: true,
          headTextButtonName: "批量修改",
          headTextButtonSize: "mini",
          textAlign: "right",
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.bid)-parseFloat(rowB.bid);
          }
        },
        {
          id: '11',
          propName: 'averageSpend',
          labelName: '平均点击单价',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.averageSpend)-parseFloat(rowB.averageSpend);
        },
          textAlign: "right",
        },
        {
          id: '7',
          propName: 'spend',
          labelName: '花费',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.spend)-parseFloat(rowB.spend);
        },
          textAlign: "right",
        },
        {
          id: '8',
          propName: 'orders',
          labelName: '订单数',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.orders)-parseFloat(rowB.orders);
        },
          textAlign: "right",
        },
        {
          id: '9',
          propName: 'sales',
          labelName: '销售额',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            return parseFloat(rowA.sales)-parseFloat(rowB.sales);
        },
          textAlign: "right",
        },
        {
          id: '10',
          propName: 'acos',
          labelName: 'ROAS',
          width: '50px',
          sortable: true,
          sortMethod: function (rowA, rowB){
            if(rowA.status != rowB.status){
              return 0;
            }
            let subNumber = isNaN(parseFloat(rowA.acos)) ? 0 : parseFloat(rowA.acos);
            let nextNumber = isNaN(parseFloat(rowB.acos)) ? 0 : parseFloat(rowB.acos);
            return subNumber - nextNumber;
          },
          textAlign: "right",
          },
        {
          id: '17',
          propName: 'maintenanceMode',
          labelName: '手动维护',
          width: '48px',
          showSwitch: true,
          activeValue: 1,
          inactiveValue: 0,
        },
        {
          id: '18',
          propName: 'operateUserIdName',
          labelName: '操作人',
          width: '58px',
        },
      ],
      params: {
        groupId: null,
        campaignId: null
      },
      date: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            id: 'yesterday',
            text: '前一天',
            onClick: (picker) => {
              console.log(this);
              const end = this.date[0] || '';
              const start = this.date[1] || '';
              const newEnd = new Date(new Date(start).setTime(new Date(start).getTime() - 3600 * 1000 * 24))
              const newStart =  new Date(new Date(end).setTime(new Date(end).getTime() - 3600 * 1000 * 24))
              picker.$emit('pick', [newStart, newEnd]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  components: {
    adsTable
  },
  created () {

  },
  activated(){
    const {groupId, campaignsId, beginDate, endDate} = this.$route.query;
    groupId > 0 &&  (this.params.groupId = groupId - 0);
    campaignsId > 0 && (this.params.campaignId = campaignsId - 0);
    (beginDate || endDate) && (this.date = [beginDate, endDate]);
    this.form.bid = this.$route.query.defaultBid;
    this.queryAdsList()
  },
  methods: {
    onQueryBtnClick() {
      this.queryAdsList();
    },
    queryAdsList () {
      adsModules.getAdGroupTargetingList({
        // 请求参数
          params:{
            groupId: this.params.groupId,
            type: 3,
            beginDate: this.date[0],
            endDate: this.date[1],
            dsTimeZone: 1
          }
      }).then((res) => {
        if(res.result !== 1){
          this.$message({
            type: 'error',
            message: '获取列表数据失败'
          });
          return
        }
        this.tableData = res.ldata;
        this.theadList[4].overallStatus = res.mdata.alloverStatus;
      }).catch((err) => {
        console.log(err)
        this.$message({
            type: 'error',
            message: err.message ? err.message : '列表数据获取失败'
          });
      })
    },
    switchChange (porpName, val, scope) {
      if(porpName == "maintenanceMode"){
        adsModules.modifyMaintenanceMode({
          id: scope.row.id,
          type: 5,
          maintenanceMode: val,
        }).then((res) => {
          if (res.result !== 1) {
            this.$message({
              type: 'error',
              message: '编辑失败!'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
          this.calculateStatus();
        }).catch((err) => {
          console.log(err)
        })
      } else if(porpName == "status") {
        adsModules.updateAdGroupTarget({
          targetId: scope.row.id,
          status: val
        }).then((res) => {
          if (res.result !== 1) {
            this.resetSwitch(val, scope);
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
          this.calculateStatus();
        }).catch((err) => {
          this.$message({
            type: 'success',
            message: err.message ? err.message : '编辑出错'
          });
        })
      }
    },
    resetSwitch (newVal, scope) {
      newVal === 1 ? scope.row.status = 0 : scope.row.status = 1
    },
    inputChange (newVal, scope, propName, oldVal) {
       adsModules.updateAdGroupTarget({
        targetId: scope.row.id,
        bid: newVal
      }).then((res) => {
        if(res.result !== 1){
          this.resetInput(scope, propName, oldVal);
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '编辑成功!'
        });
        this.queryAdsList();
      }).catch((err) => {
        this.resetInput(scope, propName, oldVal);
        this.$message({
          type: 'error',
          message: err.message ? err.message : '编辑失败'
        });
      })
    },
    imageClick (row) {
      window.open(row.productUrl);
    },
    resetInput(scope, propName, oldVal){
      scope.row[propName] = oldVal;
    },
    addProduct () {
      this.$confirm('是否确认新增商品投放?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adsModules.insertAdGroupTarget({
          value: encodeURI(this.form.asin),
          type: this.form.matchType,
          ...this.params,
          bid: this.form.bid,
          expressionType: 2
        }).then((res) => {
          if(res.result !== 1){
            this.$message({
                type: 'error',
                message: res.message ? res.message : '新增出错'
              });
              return;
            }
            this.$message({
              type: 'success',
              message: '新增成功!'
            });
            this.queryAdsList();
        }).catch((err) => {
            this.$message({
              type: 'error',
              message: err.message ? err.message : '新增出错'
            });
        })
        this.dialogFormVisible = false;
      }).catch(() => {
        this.dialogFormVisible = false
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    updateAdGroupTargetListStatusByAdGroupId (val, scope) {
      this.$confirm('此操作将改变所有投放的状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adsModules.updateAdGroupTargetListByAdGroupId({
          adGroupId: this.params.groupId,
          state: val,
          operationType: 10,
        }).then((res) => {
          if(res.result !== 1){
            this.resetSwitch(val, scope);
            this.$message({
              type: 'error',
              message: res.message ? res.message : '编辑失败'
            });
            return;
          }
          this.$message({
            type: 'success',
            message: '编辑成功!'
          });
          this.queryAdsList();
        }).catch((err) => {
          this.$message({
            type: 'success',
            message: err.message ? err.message : '编辑出错'
          });
        })
      }).catch(() => {
        this.theadList[4].overallStatus = this.theadList[4].overallStatus == 1? 2:1;
        this.$message({
          type: 'info',
          message: '已取消修改'
        });
      });
    },
    calculateStatus(){
      let tempStatus = 1;
      this.tableData.forEach(data =>{
        if(2 == data.status){
          tempStatus = 2;
        }
      });
      this.theadList[4].overallStatus = tempStatus;
    },
    updateAdGroupTargetListBidByAdGroupId (val) {
      adsModules.updateAdGroupTargetListByAdGroupId({
        adGroupId: this.params.groupId,
        bid: val,
        operationType: 11,
      }).then((res) => {
        if(res.result !== 1){
          this.$message({
            type: 'error',
            message: res.message ? res.message : '编辑失败'
          });
          return;
        }
        this.$message({
          type: 'success',
          message: '编辑成功!'
        });
        this.bidBatchEditVisible = false;
        this.queryAdsList();
      }).catch((err) => {
        this.$message({
          type: 'success',
          message: err.message ? err.message : '编辑出错'
        });
      })
    },
  }
}
</script>

<style lang="scss">
.header-box{
  .el-button{
    width: auto;
  }
}
</style>
